import React from 'react';
import cx from 'classnames';
import InfoTilesType from '~/components/@types/infoTiles';

// Components
import InfoTileV2 from '@zola/zola-ui/src/components/PreAuth/InfoTileV2';
import InfoTilesSection from '@zola/zola-ui/src/components/PreAuth/InfoTilesSection';
// Styles
import sharedLpStyles from '~/styles/landingPageShared.module.less';
import styles from './WorriedSection.module.less';
// Content
import infoTiles from './infoTilesContent';

const WorriedSection: React.FC = (): JSX.Element => {
  const renderInfoTiles = (tiles: InfoTilesType[]) =>
    tiles.map(tile => (
      <a href={tile.href}>
        <InfoTileV2
          key={tile.className}
          className={styles.infoTile}
          heading={tile.heading}
          imgSrc={tile.imgSrc}
          imgAlt={tile.imgAlt}
          href={tile.href}
        />
      </a>
    ));

  return (
    <div className={cx(sharedLpStyles.outer)}>
      <InfoTilesSection
        className={cx(sharedLpStyles.sectionContainer, sharedLpStyles.maxWidth, styles.tiles)}
        tiles={renderInfoTiles(infoTiles)}
        title="Worried You’ll Miss A Step?"
        dek={
          <div className={cx(sharedLpStyles.dek, styles.dek)}>
            We got you. We&apos;ll check in throughout the process to make sure you’re getting the
            most out of your registry.
          </div>
        }
      />
    </div>
  );
};

export default WorriedSection;
